(() => {
  const seen = new WeakSet();
  let dialog;
  let previousFocus;
  let previousOverflow;

  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'superbia-trade-success';
    dialog.setAttribute('aria-labelledby', 'superbia-trade-success-title');
    dialog.setAttribute('aria-describedby', 'superbia-trade-success-description');
    dialog.innerHTML = '<button type="button" class="superbia-trade-success-close" aria-label="Close" title="Close" autofocus>&#215;</button><h2 id="superbia-trade-success-title"></h2><p id="superbia-trade-success-description"></p><a class="button" href="/">Back to home</a>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    });
  }

  function inspectSuccess() {
    const inner = document.querySelector('[data-cf-form="WBtYDr"] .cf-form-inner[data-cf-on-success-step="true"]');
    if (!inner || seen.has(inner) || typeof HTMLDialogElement === 'undefined') return;
    const step = inner.querySelector('[data-cf-step-id="839622"]');
    const heading = step?.querySelector('h1, h2, h3, h4') || step?.querySelector('[data-cf-field-id="978736"]');
    const paragraph = step?.querySelector('p') || step?.querySelector('[data-cf-field-id="882210"]');
    if (!heading?.textContent.trim() || !paragraph?.textContent.trim()) return;
    if (!dialog) createDialog();
    // Read the actual published success copy, not a separate hard-coded message.
    dialog.querySelector('h2').textContent = heading.textContent.trim();
    dialog.querySelector('p').textContent = paragraph.textContent.trim();
    seen.add(inner);
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
  }

  function start() {
    new MutationObserver(inspectSuccess).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-cf-on-success-step']
    });
    inspectSuccess();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
